module.exports = __webpack_public_path__ + "media/images/sponsorBanner__left__top-efdf82031996a574a32d206f6310c287.png";